import React, { useState, useEffect } from 'react';
import RadioButtonLarge from './FormComponents/RadioButtonLarge';
import {
    PENSIONS_ADVISORY_SERVICE,
    FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST_ID,
    FINANCIAL_ADVISER_PENSION_TRANSFERS_NON_SPECIALIST_ID,
} from '../__constants__';
import { isIE11 } from '../utils/utilities';
import * as analytics from '../analytics';

import Button from '../components/Inputs/Button';
import Drawer from "./Drawer";

const SearchBarPopover = props => {
    const {
        visible,
        onClose,
        onSubmit,
    } = props;
    const formValueInitialState = FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST_ID;
    const [ formValue, setFormValue ] = useState(formValueInitialState);
    const [ IE11, setIE11 ] = useState(false);

    useEffect(() => {
        if (visible) {
            analytics.track('Viewed pension transfer filter', {
                category: 'Filters',
            });
        }

        const ie = isIE11()
        setIE11(ie)

    }, [ visible ]);

    const handleChange = value => {
        setFormValue(value);
    };

    const handleButtonClick = e => {
        onSubmit(formValue);
        onClose();
        setFormValue(formValueInitialState);
    };

    return (
        <Drawer
            isOpen={visible}
            type={'popover'}
            close={onClose}
        >
            <div className={`p-2 max-w-full ${IE11 ? 'w-[900px]' : 'w-[1000px]'} flex flex-wrap box-border`}>
                <div className={'grow-0 basis-full max-w-full m-0 box-border'}>
                    <h6 className={'m-0 text-[1.25rem] font-bold leading-relaxed'}>
                        <b>Do you need a pension transfer specialist?</b>
                    </h6>
                </div>
                <div className={'grow-0 basis-full max-w-full m-0 box-border'}>
                    <RadioButtonLarge
                        title="YES - choose if:"
                        onClick={handleChange}
                        value={FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST_ID}
                        selectedValue={formValue}
                        listItems={[
                            'You want to transfer a <b>final salary</b> or <b>defined benefit pension</b> (one from your employer that promises to pay out a certain income based on how much you earn when you retire)',
                            'You want to transfer a pension (either through your employer or a personal one) that has a guaranteed benefit, like a <b>Guaranteed Minimum Pension</b>',
                            '<b>PLEASE NOTE</b> that transferring out of a <b>final salary scheme</b> is unlikely to be in the best interests of most people'
                        ]}
                    />
                </div>
                <div className={'grow-0 basis-full max-w-full m-0 box-border'}>
                    <RadioButtonLarge
                        title="NO - choose if:"
                        onClick={handleChange}
                        value={FINANCIAL_ADVISER_PENSION_TRANSFERS_NON_SPECIALIST_ID}
                        selectedValue={formValue}
                        listItems={[
                            'You want to transfer a pension you have <b>through your employer</b> that is made up <b>only from regular contributions from your salary</b>, plus added <b>regular contributions from your employer</b>',
                            'You want to transfer a <b>standard personal pension</b> you’ve previously set up',
                            'You want to transfer a pension where you have a ‘Guaranteed Annuity Rate’, but no other types of guaranteed benefit',
                        ]}
                    />
                </div>
                <div className={'grow-0 basis-full max-w-full m-0 box-border'}>
                    <p className={'mt-4 text-[1.1rem] font-normal leading-normal'}>
                        Not sure? Find out more about pension types at the <a href={PENSIONS_ADVISORY_SERVICE} className={'decoration-0 no-underline text-primary-blue'} target="_blank" rel="noopener noreferrer">Pensions Advisory Service website</a>
                    </p>
                </div>
                <div className={'grow-0 basis-full max-w-full m-0 box-border flex justify-end'}>
                    <Button type={'button'} className={'w-full sm:w-auto [&_span]:text-pale-grass-green bg-mint-green hover:shadow-lg hover:bg-grass-green'} onClick={handleButtonClick} text={'Confirm'} />
                </div>
            </div>
        </Drawer>
    );
};

export default SearchBarPopover;
